/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Customer_Walkin_HintInputs */

const vi_order_customer_walkin_hint = /** @type {(inputs: Order_Customer_Walkin_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bỏ trống nếu bán khách lẻ`)
};

/**

* @param {Order_Customer_Walkin_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_customer_walkin_hint = /** @type {((inputs?: Order_Customer_Walkin_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Customer_Walkin_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_customer_walkin_hint(inputs)
});